import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "./Chess-for-peace.css";

export default function ChessForPeace() {
  return (
    <>
      <Helmet>
        <title>Chess for Peace | Gandhi Mandela Foundation</title>
        <meta
          name="description"
          content="Discover Chess for Peace, a Gandhi Mandela Foundation initiative bringing people together through thoughtful play, respect, and peaceful dialogue."
        />
      </Helmet>

      <Header />
      <main>
        <section className="page-header">
          <div className="container">
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span>/</span>
              <span>Chess for Peace</span>
            </div>
            <h1>Chess for Peace</h1>
          </div>
        </section>

        <section className="chess-intro">
          <div className="container chess-intro-content">
            <a
              href="https://www.chessveda.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="chess-feature-image"
                src="/chess/chess_for_peace.jpeg"
                alt="Chess for Peace initiative"
              />
            </a>
            <a
              href="https://www.chessveda.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="chess-btn"
            >
              Play Online Chess
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
